import { useState } from 'react'
import {
  saveSessionReflection,
  type ReportSession,
} from '../../../api/playerReports'

export function SessionReflection({
  session,
  onSaved,
}: {
  session: ReportSession
  onSaved: () => void
}) {
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const r = session.reflection
  if (r)
    return (
      <div className="report-panel">
        <h3>Tu recuerdo de esta sesión</h3>
        <p>
          Activación percibida: <strong>{r.arousal ?? 'Sin dato'}/7</strong> ·
          Control percibido: <strong>{r.control ?? 'Sin dato'}/7</strong>
        </p>
        {r.notes && <p>{r.notes}</p>}
        <p className="report-caption">
          Registrado el {new Date(r.date).toLocaleString('es-AR')}. Es tu
          recuerdo al responder; no una medición durante la jugada. 1 = nada, 7
          = mucho. No se combina con los puntajes de los cuestionarios.
        </p>
      </div>
    )
  if (!['Finalizada', 'Interrumpida'].includes(session.status)) return null
  return (
    <details className="report-disclosure">
      <summary>Sumar cómo viviste esta sesión</summary>
      <p className="report-muted">
        Opcional. Respondé sobre esta práctica. Guardamos la fecha de respuesta
        y conservamos la primera devolución.
      </p>
      <form
        className="report-reflection-form"
        onSubmit={async (e) => {
          e.preventDefault()
          const form = new FormData(e.currentTarget)
          setSaving(true)
          setError('')
          try {
            await saveSessionReflection(session.id, {
              arousal: Number(form.get('arousal')),
              control: Number(form.get('control')),
              notes: String(form.get('notes') || ''),
            })
            onSaved()
          } catch (e) {
            setError(
              e instanceof Error
                ? e.message
                : 'No pudimos guardar tu devolución.',
            )
          } finally {
            setSaving(false)
          }
        }}
      >
        {[
          ['arousal', '¿Cuánta activación o tensión recordás haber sentido?'],
          ['control', '¿Cuánto control sentiste sobre tu respuesta?'],
        ].map(([key, label]) => (
          <label key={key}>
            {label}
            <select
              className="input"
              name={key}
              defaultValue=""
              required
              disabled={saving}
            >
              <option value="" disabled>
                Elegí una respuesta
              </option>
              {[1, 2, 3, 4, 5, 6, 7].map((n) => (
                <option key={n} value={n}>
                  {n}
                  {n === 1 ? ' · Nada' : n === 7 ? ' · Mucho' : ''}
                </option>
              ))}
            </select>
          </label>
        ))}
        <label>
          ¿Qué te ayudó o te dificultó la práctica? (opcional)
          <textarea
            className="input"
            name="notes"
            maxLength={500}
            rows={3}
            disabled={saving}
          />
        </label>
        {error && <p role="alert">{error}</p>}
        <button className="btn btn-primary" disabled={saving}>
          {saving ? 'Guardando…' : 'Guardar mi experiencia'}
        </button>
      </form>
    </details>
  )
}
